import Input from "components/_partials/Input";
import { Activity } from "models/activity";

interface ReviewInterestFormProps {
  reviewInterestFormik: any;
  isFormSubmitted: boolean;
  hasError: boolean;
  activities: any;
}
const ReviewInterestForm = (props: ReviewInterestFormProps) => {
  const { reviewInterestFormik, hasError, isFormSubmitted, activities } = props;
  return (
    <div className="w-container">
      <div className="form-block w-form">
        <form
          id="email-form"
          name="email-form"
          data-name="Email Form"
          method="get"
          className="form"
        >
          <div>
            {(activities || []).map((activity: Activity, index: number) => (
              <div key={activity.Activity_Name}>
                <Input
                  label={
                    index === 0
                      ? "AFTER YOU HAVE REVIEW EACH ACTIVITY, Please make your selection:"
                      : ""
                  }
                  radioLabel={activity.Activity_Name}
                  name="activity"
                  type="radio"
                  value={activity.Activity_ID}
                  onChange={reviewInterestFormik.handleChange}
                />
              </div>
            ))}
            {reviewInterestFormik.errors.activity &&
              reviewInterestFormik.touched.activity && (
                <span className="error_text">
                  {reviewInterestFormik.errors.activity}
                </span>
              )}
          </div>
          <Input
            label="Comments"
            name="comment"
            type="text"
            value={reviewInterestFormik.values.comment}
            onChange={reviewInterestFormik.handleChange}
          />
        </form>
        {isFormSubmitted && !hasError && (
          <div className="w-form-done">
            <div>Thank you! Your submission has been received!</div>
          </div>
        )}
        {isFormSubmitted && hasError && (
          <div className="w-form-fail">
            <div>Oops! Something went wrong while submitting the form.</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReviewInterestForm;
